var scope_0 = require('/vercel/path0/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f29420837909467d42c21678b73360a5.js').default;export default
        Object.assign({}, scope_0 )
    